module.exports = __webpack_public_path__ + "img/BG@3x@3x.127e8a85.png";